<template>
  <div id="footer">
    <p>Camber Strategic Partners, LLC 2017</p>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>
  p {
    margin: 0;
    height: 100%;
  }

  #footer {
    height: 72px;
    line-height: 72px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue